<template>
  <div class="promotion-content">
    <starter-edition-sales v-if="showStarterEditionSales" :action="saleAction" />
    <promotion-end v-if="showEndPrompt" />
    <promotion-prompt
     v-if="showPromptPage"
     :background="promptPageBackgroundColor"
     :prompt="promptPagePrompt"
     :alert="promptPageAlertMsg"
     :alertCallback="promptAlertCallback"
    />
  </div>
</template>

<script>
import { i18n } from '@/utils/i18n'
import StarterEditionSales from './StarterEditionSales'
import PromotionEnd from './PromotionEnd'
import PromotionPrompt from './PromotionPrompt'

const salesTypeMap = {
  starterEdition: '1001'
}

export default {
  name: 'PromotionSales',
  i18n,
  components: {
    StarterEditionSales,
    PromotionEnd,
    PromotionPrompt
  },
  created () {
    document.title = '亿方云送福利'
    this.saleType = this.$route.query.type === '110' ? '1001' : this.$route.query.type
    this.saleAction = this.$route.query.type === '110' ? 'finish' : 'start'
    this.showEndPrompt = salesTypeMap.starterEdition === this.saleType && Date.now() > new Date('2020-09-01 00:00:00 GMT+8')
    this.showStarterEditionSales = salesTypeMap.starterEdition === this.saleType && !this.showEndPrompt
    // 1002
    if (this.saleType === '1404') {
      this.showPromptPage = true
      this.promptPageBackgroundColor = 'linear-gradient(to right, #3b076a 0.00%, #5c0882 48.29%, #3b076a 100.00%)'
      this.promptPageAlertMsg = '请电脑端登录亿方云领取169元专享礼包登录地址：https://www.fangcloud.com'
      this.promptAlertCallback = function () {
        window.location.href = `${window.location.origin}/h5/`
      }
    }
  },
  data () {
    return {
      saleType: '',
      saleAction: '',
      showStarterEditionSales: false,
      showEndPrompt: false,
      showPromptPage: false,
      promptPageBackgroundColor: '#ffffff',
      promptPageAlertMsg: '',
      promptPagePrompt: '',
      promptAlertCallback: Function
    }
  },
  computed: {},
  watch: {},
  methods: {}
}
</script>

<style lang="postcss">
@import "variables";
.promotion-content{
  display: flex;
  height: 100%;
  width: 100%;
}
</style>
